import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router";
import { BotChat } from "../../interfaces/chabot";
import { useDeleteChat } from "../Sirius/SiriusQueries";
import { DialogProps } from "./useDialogs";

function DeleteChatDialog({ payload, open, onClose }: DialogProps<BotChat>) {
  const { mutate: deleteMutate } = useDeleteChat(payload.bot.id);
  const navigate = useNavigate();

  const handleDelete = () => {
    deleteMutate(payload.id);
    onClose();
    navigate(`/sirius/bot/${payload.bot.id}/chat/new`);
  };
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>Supprimer la conversation</DialogTitle>
      <DialogContent>
        Etes vous sûr de vouloir supprimer "{payload.title}"?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteChatDialog;
